import { MutationCache } from '@tanstack/react-query';

export function createMutationCache(handleError: (error: Error) => void) {
  return new MutationCache({
    onError: (error, _, __, mutation) => {
      if (mutation.meta?.ignoreError) {
        return;
      }
      handleError(error);
    },
  });
}
